import { render, staticRenderFns } from "./PostContent.vue?vue&type=template&id=615d8d70&scoped=true"
import script from "./PostContent.vue?vue&type=script&lang=js"
export * from "./PostContent.vue?vue&type=script&lang=js"
import style0 from "./PostContent.vue?vue&type=style&index=0&id=615d8d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d8d70",
  null
  
)

export default component.exports